export const PREPARE_RETAINER_FILES = 'prepare_retainer_files'


// WEBPACK FOOTER //
// ./src/modules/process/ui-definition/sales-order/retainer-refinement/task-name.js